import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap";
import { getNames } from 'country-list';

const EventForm = ({ isRsvp, setIsRsvp, eventLocation, setEventLocation, eventType, setEventType, eventStartDate, setEventStartDate, eventStartTime, setEventStartTime, eventEndTime, setEventEndTime, isOnline, setIsOnline }) => {

  const [showFullForm, setShowFullForm] = useState(false);
  const [formData, setFormData] = useState({
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: null,
  });

  useEffect(() => {
    const { address1, address2, city, state, country } = formData;
    const fullAddress = [address1, address2, city, state, country]
      .filter(Boolean) // remove empty strings
      .join(', ');
    setEventLocation(fullAddress);
  }, [formData]);

  const countryList = getNames();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Card className="p-3">
      <h2 className="mb-3">Date and Location</h2>
      {/* Event Type */}
      <FormGroup>
        <Label>Type of Event</Label>
        <div className="d-flex">
          <Button
            color={eventType === "single" ? "primary" : "light"}
            onClick={() => setEventType("single")}
          >
            Single Event
          </Button>
          <Button
            color={eventType === "recurring" ? "primary" : "light"}
            onClick={() => setEventType("recurring")}
            className="ms-2"
          >
            Recurring Event
          </Button>
        </div>
      </FormGroup>

      <FormGroup>
        <div className="d-flex">
          <Label>RSVP Event</Label>
          <input
            type="checkbox"
            checked={isRsvp == 'false' ? false : true}
            style={{ transform: "scale(1.5)", marginLeft: "10px", marginBottom: "8px" }}
            onClick={() => setIsRsvp(isRsvp == 'false' ? 'true' : 'false')}
          />
        </div>
      </FormGroup>

      {/* Date & Time for Single Event */}
      {eventType === "single" && (
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label>Date</Label>
              <Input type="date" value={eventStartDate} onChange={(e) => setEventStartDate(e.target.value)} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>Start Time</Label>
              <Input type="time" value={eventStartTime} onChange={(e) => setEventStartTime(e.target.value)} />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label>End Time</Label>
              <Input type="time" value={eventEndTime} onChange={(e) => setEventEndTime(e.target.value)} />
            </FormGroup>
          </Col>
        </Row>
      )}

      {/* Location Type */}
      <FormGroup>
        <Label>Location</Label>
        <div className="d-flex">
          <Button
            color={isOnline === "no" ? "primary" : "light"}
            onClick={() => setIsOnline("no")}
          >
            Venue
          </Button>
          <Button
            color={isOnline === "yes" ? "primary" : "light"}
            onClick={() => setIsOnline("yes")}
            className="ms-2"
          >
            Online Event
          </Button>
          <Button
            color={isOnline === "tba" ? "primary" : "light"}
            onClick={() => setIsOnline("tba")}
            className="ms-2"
          >
            To Be Announced
          </Button>
        </div>
      </FormGroup>

      {/* Location Input */}
      {isOnline === "no" && (
        <FormGroup>
          {/* <Label>Location</Label> */}
          <Input type="text" value={eventLocation} onChange={(e) => setEventLocation(e.target.value)} placeholder="Enter location" />
          {!showFullForm ? (<p style={{ fontSize: "0.8rem" }} className="mt-2 cursor-pointer" onClick={() => setShowFullForm(true)}> <FontAwesomeIcon icon={faHome} /> Add location details</p>) : (
            <div className="mt-3 add-manual-address">
              <Row className="gy-3">
                <Col xs={12} md={4}>
                  <Input
                    type="text"
                    name="address1"
                    value={formData.address1}
                    onChange={handleChange}
                    placeholder="Address 1 *"
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={4}>
                  <Input
                    type="text"
                    name="address2"
                    value={formData.address2}
                    onChange={handleChange}
                    placeholder="Address 2"
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={4}>
                  <Input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="City *"
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <Input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    placeholder="e.g. California"
                    className="form-control"
                  />
                </Col>
                <Col xs={12} md={6}>
                  <Input
                    type="select"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">Select Country *</option>
                    {countryList.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </div>
          )}
        </FormGroup>
      )}

      {isOnline === "yes" && (
        <FormGroup>
          {/* <Label>Location</Label> */}
          <Input type="text" value={eventLocation} onChange={(e) => setEventLocation(e.target.value)} placeholder="Enter Meeting Link" />
        </FormGroup>
      )}
      {/* Google Map Placeholder */}
      {isOnline === "no" && (
        <div style={{ width: "100%", height: "300px", backgroundColor: "#e3e3e3", textAlign: "center", lineHeight: "200px" }}>
          <iframe
            title="Event Location"
            width="100%"
            height="300px"
            style={{ border: 0 }}
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao&q=${encodeURIComponent(
              eventLocation || "London, UK"
            )}`}
            allowFullScreen
          ></iframe>
        </div>
      )}

      {/* Reserved Seating */}
      {/* <FormGroup className="mt-3">
        <Label>Reserved Seating</Label>
        <div style={{ fontSize: "small", color: "gray" }}>
          Use your venue map to set price tiers for each section and choose whether attendees can pick their seat.
        </div>
      </FormGroup> */}
    </Card>
  );
};

export default EventForm;
